import type { Theme } from "@mui/material";

export const DROPDOWN_STYLES = {
  minHeight: "40px",
  ".MuiSelect-select": {
    color: "text.med",
    fontSize: "0.875rem",
    fontFamily: (theme: Theme) => theme.typography.fontFamily,
  },
  "&.MuiList-root": {
    p: 1,
  },
  "&.Mui-disabled": {
    bgcolor: "shades.neutral.50",
  },
  "& .MuiSelect-icon": {
    p: 0.5,
    color: "icon.weak",
  },
};

export const TEXT_VARIANT_STYLES = {
  ".MuiOutlinedInput-notchedOutline": {
    display: "none",
  },
  "&:hover:not(.Mui-focused):not(.Mui-disabled) > .MuiOutlinedInput-notchedOutline":
    {
      border: "none",
    },
};
